import React from 'react'

const Navbar = () => {
  return (
    <>
            <nav className="main-nav">
             
                <div className="logo">
                    <h2>
                   MultiStepForm
                        
                    </h2>
                </div>

                
            </nav>
                      
        </>
  )
}

export default Navbar
